import { useCompaniesTableStore } from "@/stores/useTableStore";

import { useAuth } from "../../../../../context/Auth/AuthProvider";
import { USER_PERMISSIONS } from "../../../../../roles/types/enums";
import { STEP_GROUP } from "../../../types";
import useTutorialMode from "../../useTutorialMode";

const useDesktopActions = (
  isCompaniesPage: boolean,
  handleTutorialCompletion: (stepGroup: STEP_GROUP) => Promise<void>
) => {
  const {
    stepGroup,
    stepIndex,
    handleTutorialStepIndexChange,
    setIsSettingsOpen,
    setTutorialDetails
  } = useTutorialMode();

  const resetCompaniesTableDetails = useCompaniesTableStore(
    state => state.resetTableDetails
  );

  const { getAccessStatus } = useAuth();

  const canManageCompanyCards = getAccessStatus(
    USER_PERMISSIONS.ManageCompanies
  );

  const companyCardsStepsCount = canManageCompanyCards ? 1 : 2;

  const handlePreviousButtonDesktop = () => {
    switch (stepIndex) {
      case 1:
      case 2:
        if (stepIndex === 1 || isCompaniesPage) {
          setTutorialDetails({
            isTutorialOpen: false,
            stepIndex: 0,
            stepGroup: STEP_GROUP.TutorialNewCompanyCard,
            isTutorialActive: true
          });

          setTimeout(() => {
            document.getElementById("desktopSettingsButton")?.click();
          }, 200);
        } else {
          handleTutorialStepIndexChange(stepIndex - 1);
        }
        break;

      case 3:
        resetCompaniesTableDetails();
        handleTutorialStepIndexChange(stepIndex - 1);
        break;

      case 5:
        handleTutorialStepIndexChange(stepIndex - companyCardsStepsCount);
        break;

      default:
        handleTutorialStepIndexChange(stepIndex - 1);
        break;
    }
  };

  const handleNextButtonDesktop = () => {
    const indexNumber = isCompaniesPage ? 2 : 1;
    switch (stepIndex) {
      case 0:
        setIsSettingsOpen(false);
        isCompaniesPage && resetCompaniesTableDetails();

        setTutorialDetails({
          isTutorialOpen: true,
          stepIndex: indexNumber,
          stepGroup: stepGroup,
          isTutorialActive: true
        });

        break;

      case 3:
        handleTutorialStepIndexChange(stepIndex + companyCardsStepsCount);
        break;

      case 5:
        handleTutorialCompletion(STEP_GROUP.TutorialNewCompanyCard);
        break;

      default:
        handleTutorialStepIndexChange(stepIndex + 1);
        break;
    }
  };

  return {
    handlePreviousButtonDesktop,
    handleNextButtonDesktop
  };
};

export default useDesktopActions;
